import './Style.scss';
import * as React from 'react';
import { Col, Dropdown, DropdownItem } from 'react-bootstrap';
import { ChartModel } from 'Interfaces/ChartInterface';
import { getLocalization } from 'global/global';
import RadarChartData from './RadarChartData';

interface Props {
  children: JSX.Element;
  selected: string[];
  model: ChartModel;
  updateModel: (model: Partial<ChartModel>) => void;
}

export default function RadarChartLines(props: Props) {
  const [showDropdown, setShowDropdown] = React.useState(false);
  const [formId, setFormId] = React.useState('');
  const { model } = props;

  React.useEffect(() => {
    const formIds = Object.keys(model.forms);
    if (formIds.length) {
      setFormId(formIds[0]);
    }
  }, [model.forms]);


  const onDataPointSelected = (value, checked) => {
    const { model } = props;
    if (checked) {
      props.updateModel({ dataPoints: model.dataPoints.concat([value])});
    } else {
      props.updateModel({ dataPoints: model.dataPoints.filter(v => v !== value)});
    }
  };

  const onToggle = (isOpen, metadata) => {
    if (metadata.source === 'select') {
      setShowDropdown(true);
    } else {
      setShowDropdown(isOpen);
    }
  };

  return (
    <Col md={8}>
      <div className="btn-group chart-content-spacing">
        <Dropdown
          onToggle={onToggle}
          show={showDropdown}
        >
          <Dropdown.Toggle variant="primary"  size="sm" id="dropdown-basic">
            {getLocalization('addLines')}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <RadarChartData
              formId={formId}
              dataFilter={model.dataFilter}
              selected={props.selected}
              ListItem={DropdownItem}
              questions={formId ? model.forms[formId].questions : []}
              onDataPointSelected={onDataPointSelected}
              onDataFilterSelected={(value) => props.updateModel({...model, dataFilter: value})}
            />
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {props.children}
    </Col>
  );
}
